// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-o_fe","advertDetailServiceList__header":"c-o_ff","advertDetailServiceList__list":"c-o_fg"};